function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1862 24.9305H17.8369V29.8869H13.1862V24.9305Z",
  fill: "url(#paint0_linear_18_21971)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1862 24.9305H17.8369V29.8869H13.1862V24.9305Z",
  fill: "url(#paint1_linear_18_21971)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1862 24.9305H17.8369V29.8869H13.1862V24.9305Z",
  fill: "url(#paint2_radial_18_21971)"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_18_21971)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.04352 14.5476C4.04352 11.51 6.50595 9.04761 9.54352 9.04761H22.4565C25.4941 9.04761 27.9565 11.51 27.9565 14.5476V23.9306C27.9565 24.4829 27.5088 24.9306 26.9565 24.9306H5.04352C4.49123 24.9306 4.04352 24.4829 4.04352 23.9306V14.5476Z",
  fill: "url(#paint3_linear_18_21971)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.04352 14.5476C4.04352 11.51 6.50595 9.04761 9.54352 9.04761H22.4565C25.4941 9.04761 27.9565 11.51 27.9565 14.5476V23.9306C27.9565 24.4829 27.5088 24.9306 26.9565 24.9306H5.04352C4.49123 24.9306 4.04352 24.4829 4.04352 23.9306V14.5476Z",
  fill: "url(#paint4_radial_18_21971)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.04352 14.5476C4.04352 11.51 6.50595 9.04761 9.54352 9.04761H22.4565C25.4941 9.04761 27.9565 11.51 27.9565 14.5476V23.9306C27.9565 24.4829 27.5088 24.9306 26.9565 24.9306H5.04352C4.49123 24.9306 4.04352 24.4829 4.04352 23.9306V14.5476Z",
  fill: "url(#paint5_radial_18_21971)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.04352 14.5476C4.04352 11.51 6.50595 9.04761 9.54352 9.04761H22.4565C25.4941 9.04761 27.9565 11.51 27.9565 14.5476V23.9306C27.9565 24.4829 27.5088 24.9306 26.9565 24.9306H5.04352C4.49123 24.9306 4.04352 24.4829 4.04352 23.9306V14.5476Z",
  fill: "url(#paint6_radial_18_21971)"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_18_21971)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.30309 24.4375H12.9528C13.4603 24.4375 13.8716 24.0186 13.8716 23.5019V14.7233C13.8716 11.9874 11.853 9.58707 9.12793 9.58709C6.55631 9.42392 4.38422 11.5019 4.38422 14.7233V23.5019C4.38422 24.0186 4.79559 24.4375 5.30309 24.4375Z",
  fill: "url(#paint7_linear_18_21971)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.30309 24.5625H12.9528C13.5314 24.5625 13.9966 24.0855 13.9966 23.5019V14.7233C13.9966 11.9327 11.9363 9.46439 9.13189 9.46209C6.47751 9.29595 4.25922 11.4445 4.25922 14.7233V23.5019C4.25922 24.0855 4.72444 24.5625 5.30309 24.5625Z",
  stroke: "url(#paint8_radial_18_21971)",
  strokeWidth: 0.25
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_ii_18_21971)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.2905 3.14062H24.6702C25.112 3.14062 25.4702 3.4988 25.4702 3.94063V7.05938C25.4702 7.5012 25.112 7.85938 24.6702 7.85938H19.2905V3.14062Z",
  fill: "#F64092"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_i_18_21971)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 6.62866,
  y: 20.0144,
  width: 5.70466,
  height: 1.93105,
  rx: 0.965524,
  fill: "url(#paint9_linear_18_21971)"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_f_18_21971)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 7.11383,
  y: 21.0737,
  width: 4.48438,
  height: 0.363831,
  rx: 0.181915,
  fill: "url(#paint10_linear_18_21971)"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_f_18_21971)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.4623 3.41797H24.7748C24.8712 3.42318 25.0858 3.50391 25.1733 3.78516",
  stroke: "#F667A3",
  strokeWidth: 0.15,
  strokeLinecap: "round"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter6_i_18_21971)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.6337 3.28931C17.6337 2.65491 18.148 2.14062 18.7824 2.14062C19.4168 2.14062 19.9311 2.65491 19.9311 3.28931V12.9062H17.6337V3.28931Z",
  fill: "url(#paint11_linear_18_21971)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.6337 3.28931C17.6337 2.65491 18.148 2.14062 18.7824 2.14062C19.4168 2.14062 19.9311 2.65491 19.9311 3.28931V12.9062H17.6337V3.28931Z",
  fill: "url(#paint12_linear_18_21971)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.6337 3.28931C17.6337 2.65491 18.148 2.14062 18.7824 2.14062C19.4168 2.14062 19.9311 2.65491 19.9311 3.28931V12.9062H17.6337V3.28931Z",
  fill: "url(#paint13_radial_18_21971)"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter7_f_18_21971)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 18.924,
  y: 2.89062,
  width: 0.616455,
  height: 9.85156,
  rx: 0.308228,
  fill: "#C0B9CA"
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6342 11.9375C17.0029 12.336 16.7514 13.1233 16.7514 14.0293C16.7514 15.3377 17.4191 16.3984 18.7275 16.3984C20.0359 16.3984 21.0966 15.3377 21.0966 14.0293C21.0966 13.1233 20.6823 12.336 19.935 11.9375H17.6342Z",
  fill: "url(#paint14_radial_18_21971)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6342 11.9375C17.0029 12.336 16.7514 13.1233 16.7514 14.0293C16.7514 15.3377 17.4191 16.3984 18.7275 16.3984C20.0359 16.3984 21.0966 15.3377 21.0966 14.0293C21.0966 13.1233 20.6823 12.336 19.935 11.9375H17.6342Z",
  fill: "url(#paint15_radial_18_21971)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6342 11.9375C17.0029 12.336 16.7514 13.1233 16.7514 14.0293C16.7514 15.3377 17.4191 16.3984 18.7275 16.3984C20.0359 16.3984 21.0966 15.3377 21.0966 14.0293C21.0966 13.1233 20.6823 12.336 19.935 11.9375H17.6342Z",
  fill: "url(#paint16_radial_18_21971)"
});

var _ref16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_18_21971",
  x: 4.04352,
  y: 8.64761,
  width: 24.313,
  height: 16.2831,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.4,
  dy: -0.4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.375
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_21971"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_18_21971",
  x: 3.63422,
  y: 8.828,
  width: 10.9874,
  height: 16.3595,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  result: "effect1_foregroundBlur_18_21971"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_ii_18_21971",
  x: 19.2905,
  y: 2.89062,
  width: 6.67969,
  height: 5.11875,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: -0.25
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.847059 0 0 0 0 0.14902 0 0 0 0 0.501961 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_21971"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.5,
  dy: 0.15
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.847059 0 0 0 0 0.14902 0 0 0 0 0.501961 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_21971",
  result: "effect2_innerShadow_18_21971"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_i_18_21971",
  x: 6.12866,
  y: 20.0144,
  width: 6.20465,
  height: 2.43103,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.5,
  dy: 0.5
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.375
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.117647 0 0 0 0 0.321569 0 0 0 0 0.823529 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_21971"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_f_18_21971",
  x: 6.61383,
  y: 20.5737,
  width: 5.48438,
  height: 1.36377,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  result: "effect1_foregroundBlur_18_21971"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_f_18_21971",
  x: 19.2373,
  y: 3.19302,
  width: 6.16096,
  height: 0.817212,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.075,
  result: "effect1_foregroundBlur_18_21971"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6_i_18_21971",
  x: 17.6337,
  y: 1.84062,
  width: 2.59736,
  height: 11.0656,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.3,
  dy: -0.3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.425
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.439216 0 0 0 0 0.427451 0 0 0 0 0.466667 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_21971"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter7_f_18_21971",
  x: 18.424,
  y: 2.39062,
  width: 1.61646,
  height: 10.8516,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  result: "effect1_foregroundBlur_18_21971"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_18_21971",
  x1: 16.8217,
  y1: 29.8869,
  x2: 13.1862,
  y2: 29.8869,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8F616C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.419865,
  stopColor: "#7D4261"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77392,
  stopColor: "#5E3A43"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_18_21971",
  x1: 18.103,
  y1: 29.8869,
  x2: 17.353,
  y2: 29.8869,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#855A5D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#855A5D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_18_21971",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(15.5115 29.8869) rotate(-90) scale(4.95639 5.62268)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.771623,
  stopColor: "#632F53",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5A3A46"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_18_21971",
  x1: 20.5248,
  y1: 24.9306,
  x2: 20.5248,
  y2: 11.2501,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.742721,
  stopColor: "#4396FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#59A1FF"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_18_21971",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16 8.31256) rotate(90) scale(4.0625 18.8502)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0615385,
  stopColor: "#4D70A0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D93EB",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_18_21971",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(18.4936 14.3126) rotate(90) scale(3.3125 2.64062)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.612785,
  stopColor: "#2356E3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4398FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial_18_21971",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.7123 11.3438) rotate(-127.25) scale(3.76883 1.66127)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.111693,
  stopColor: "#114CA0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2476C7",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_18_21971",
  x1: 9.12793,
  y1: 9.58707,
  x2: 9.12793,
  y2: 24.4375,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3A7DF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D7DFF"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint8_radial_18_21971",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(15.4467 12.0073) rotate(125.738) scale(9.4165 3.1675)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.262572,
  stopColor: "#5C9DFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5C9DFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_18_21971",
  x1: 9.48099,
  y1: 20.0144,
  x2: 9.48099,
  y2: 21.9455,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3B6BF1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1872E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_18_21971",
  x1: 7.11383,
  y1: 21.2556,
  x2: 10.9155,
  y2: 21.2556,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#568FF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#568FF7",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_18_21971",
  x1: 18.103,
  y1: 8.625,
  x2: 19.9311,
  y2: 8.625,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9A85B2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B9AFC7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_18_21971",
  x1: 18.7824,
  y1: 2.14062,
  x2: 18.7824,
  y2: 3.84375,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8C8893"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8C8893",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint13_radial_18_21971",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.4467 11.9375) rotate(-90) scale(0.21875 1.64063)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0714286,
  stopColor: "#C3BFCA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C3BFCA",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint14_radial_18_21971",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(18.4467 16.1875) rotate(-90) scale(3.34375 3.06638)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9F71CD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9994A1"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint15_radial_18_21971",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.478 13.75) rotate(169.651) scale(3.65318 4.36719)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.548315,
  stopColor: "#73679F",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#60569A"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint16_radial_18_21971",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.0873 13.0156) rotate(-31.1951) scale(1.99101 1.4825)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0788116,
  stopColor: "#CBC4D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AFABB5",
  stopOpacity: 0
})));

function SvgClosedMailboxWithRaisedFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedMailboxWithRaisedFlag);
export default __webpack_public_path__ + "static/media/closed-mailbox-with-raised-flag.f4a179f5.svg";
export { ForwardRef as ReactComponent };